<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">Add universe</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="name">
                    <div class="gcmcn-form-label">Name</div>
                    <el-input
                        size="mini"
                        v-model="form.display_name"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    v-if="this.universe === null"
                    class="gcmcn-form-input"
                    prop="event_uid"
                >
                    <div class="gcmcn-form-label">Entity</div>
                    <el-select
                        v-model="form.entity_uid"
                        popper-class="gcmcn-popper"
                        size="mini"
                        placeholder="Select an entity"
                    >
                        <el-option
                            v-for="entity in $store.getters.entities"
                            :key="entity.uid"
                            :label="entity.display_name"
                            :value="entity.uid"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {

    components: {
    },

    props: {
        universe: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        }
    },

    data (){
        return {
            form: {
                name: '',
                display_name: '',
                entity_uid: '',
            },
            loading: false,
        };
    },

    computed: {
        rules () {
            return {
                name: [{ required: true, validator: this.authorizedCharacters }],
                entity_uid: [{ required: this.universe !== null ? true : false }],
            };
        },

    },

    watch: {
        universe: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        }
    },

    created (){
    },

    methods: {
        setForm (){
            if(this.universe){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.universe)));
                this.form.entity_uid = this.universe.scopes.entity_uid;
            }else{
                this.$set(this, 'form', {
                    name: '',
                    display_name: '',
                    entity_uid: '',
                });
            }
        },
        authorizedCharacters(rule, value, callback) {
            if(!this.form.display_name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.display_name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                        this.loading = false;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let action;
                    let postData = { item: form, model: 'universes'};
                    let messageType = this.universe ? 'update' : 'create';
                    if(this.universe){
                        action = 'patchItem';
                        this.form.url = this.universe.url;
                    }else{
                        form.name = form.display_name;
                        action = 'createItem';
                        form.can_admin_users = [this.$store.getters.currentUser.uid];
                        postData.url = this.$store.state.api.meta.listModels.universes.url;
                        postData.scopes = {'X-Entity-Uid': form.entity_uid};
                    }
                    this.$store.dispatch(action, postData).then((res) => {
                        this.$message({
                            message: `Universe ${messageType}d!`,
                            type: 'success'
                        });
                        this.show = false;
                        this.$emit('universe-created');
                        this.loading = false;
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on universe ${messageType === 'update' ? messageType : 'creation'}.`);
                        this.loading = false;
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        }
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Universes/universe-form.vue